import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./customer-side/customer-side.routes').then(m => m.CUSTOMER_ROUTES),
  }, {
    path: 'backoffice',
    loadChildren: () => import('./backoffice/backoffice.module').then(m => m.BackofficeModule),
  }, {
    path: 'acces-client',
    loadChildren: () => import('./acces-client/acces-client.module').then(m => m.AccesClientModule),
  }, {
    path: 'gestion',
    loadChildren: () => import('./gestion/gestion.module').then(m => m.GestionModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

